













import { Vue, Component, Prop } from 'vue-property-decorator';
import { INavData } from '@/interfaces/nav-data.interface';
import NavBarBtn from '@/components/nav-bar-btn.vue';
import NavBarMenu from '@/components/nav-bar-menu.vue';

@Component({
  components: {
    NavBarBtn,
    NavBarMenu,
  },
})
export default class NavBar extends Vue {
  @Prop({ required: true })
  readonly items!: INavData[];

  @Prop()
  readonly disabled!: boolean;
}
